import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Alert,
} from "reactstrap";
import { toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import { base_api_url } from "../../../config";
import { auth } from "../../../axious";
import Context from "../../../store/Context";

const Login = ({ status, setStatus }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setJwt } = useContext(Context);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setJwt(null);
      localStorage.removeItem("token");
      setStatus(0);
      // window.location.reload()
    }
  }, []);

  const login = async (username, password) => {
    try {
      await axios
        .post(base_api_url + auth.login, {
          email: username,
          password: password,
        })
        .then(function (response) {
          // console.log("response", response);
          setJwt(response.data.token);
          localStorage.setItem("token", response.data.token);
          setStatus(1);
        })
        .catch(function (error) {
          console.log(error);
          setStatus(2);
        });
    } catch (error) {
      toast.error("invalid data");
    }
  };

  return (
    <div className="app flex-row align-items-center">
      <Container>
        {status === 1 && <Redirect from="#/login" to="/dashboard" />}

        <Row className="justify-content-center">
          <Col md="8">
            {status === 1 ? (
              <Alert color="success">Logged in successfully</Alert>
            ) : null}
            {status === 2 ? (
              <Alert color="warning">Incorrect username or password</Alert>
            ) : null}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            <CardGroup>
              <Card className="p-4">
                <CardBody>
                  <h1>Login</h1>
                  <p className="text-muted">Sign In to your account</p>
                  <form autocomplete="on">
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        autocomplete="on"
                        type="text"
                        placeholder="Username"
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        autocomplete="on"
                        type="password"
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </InputGroup>
                  </form>
                  <Row>
                    <Col xs="6">
                      <Button
                        color="primary"
                        className="px-4"
                        onClick={() => login(username, password)}
                      >
                        Login
                      </Button>
                    </Col>
                    {/* <Col xs="6" className="text-right">
                      <Button color="link" className="px-0">Forgot password?</Button>
                    </Col> */}
                  </Row>
                </CardBody>
              </Card>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js